import { format } from 'date-fns';
import { IDateTimeAudienceCountry } from '../context/types';
import { getDateTimeAudienceStorage } from '../context/utils';
import { IDateAudienceData } from './types';


export function GetDatePartCurrent(gmt: number): IDateAudienceData {
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const localWithGmt = new Date(utc + 3600000 * gmt);
    return GetDatePart(localWithGmt);
}

export function GetDatePart(dateVal: Date): IDateAudienceData {
    let day, month, year, fullDate, fullDateFormat;
    day = dateVal.getDate();
    day = day.toString().padStart(2, 0)
    month = dateVal.getMonth() + 1;
    month = month.toString().padStart(2, 0);
    year = dateVal.getFullYear();
    fullDate = dateVal;
    fullDateFormat = format(dateVal, "yyyy-MM-dd'T'HH:mm:ss");

    return {
        day, month, year, fullDate, fullDateFormat
    }
}
export function getDateFromTimeString(timeString: string) {
    if (timeString.indexOf(':') >= 0) {
        let dateResult: Date = new Date();
        let timeDateParts = timeString.split(":");
        if (timeDateParts.length === 3) {
            const timeHour = Number(timeDateParts[0]);
            const timeMinutes = Number(timeDateParts[1]);
            const timeSeconds = Number(timeDateParts[2]);
            dateResult.setHours(timeHour, timeMinutes, timeSeconds);
        }
        return dateResult;
    }
    return null;
}

export function getDateFromDateTimeAudienceCountry(
    dataTime: IDateTimeAudienceCountry
) {
    let dateIni = getDateFromTimeString(dataTime.HoraIni);
    let dateEnd = getDateFromTimeString(dataTime.HoraFim);
    return {
        dateIni,
        dateEnd,
    };
}
type DateTypeResult =  Date | null | undefined;
export function getTimeHoursDefault(
    dateData: DateTypeResult,
    hoursDefault: number
) {
    return dateData?.getHours() ?? hoursDefault;
}

export function getTimeMinutesDefault(
    dateData:DateTypeResult,
    minutesDefault: number
) {
    return dateData?.getMinutes() ?? minutesDefault;
}
export function getTimeSecondsDefault(
    dateData: DateTypeResult,
    secondsDefault: number
) {
    return dateData?.getSeconds() ?? secondsDefault;
}
export function getDefaultAudience(
    dateTimeAudienceData: IDateTimeAudienceCountry | undefined
) {
    let dataResult = { hoursDefaultIni: 6, minutesDefaultIni: 0, secondsDefaultIni: 0 };
    if (!dateTimeAudienceData) {
        const storedData = getDateTimeAudienceStorage();
        if (storedData) {
            dateTimeAudienceData ??= storedData;
        }
    }
    if (dateTimeAudienceData) {
        let dateCountry = getDateFromDateTimeAudienceCountry(dateTimeAudienceData);

        dataResult.hoursDefaultIni = getTimeHoursDefault(dateCountry?.dateIni, dataResult.hoursDefaultIni);
        dataResult.minutesDefaultIni = getTimeMinutesDefault(dateCountry?.dateIni, 0);
        dataResult.secondsDefaultIni = getTimeSecondsDefault(dateCountry?.dateIni, 0);
    }
    return dataResult;
}
